import { stories, categories } from '@/mocks/stories';
import type { Story, Category } from '@/mocks/stories';

export { stories, categories };
export type { Story, Category };

export function getStoryById(id: string): Story | undefined {
  return stories.find((item) => item.id === id);
}

export function getHotStories(limit = 5): Story[] {
  return [...stories].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function getLatestStories(limit = 6): Story[] {
  return [...stories]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, limit);
}

export function getRelatedStories(current: Story, limit = 3): Story[] {
  const sameCategory = stories.filter(
    (item) => item.id !== current.id && item.category === current.category,
  );
  const others = stories.filter(
    (item) => item.id !== current.id && item.category !== current.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function filterStories(options: { category?: string; keyword?: string }): Story[] {
  const { category, keyword } = options;
  const kw = (keyword || '').trim().toLowerCase();
  return stories.filter((item) => {
    const matchCategory = !category || category === 'all' || item.category === category;
    const matchKeyword =
      !kw ||
      item.title.toLowerCase().includes(kw) ||
      item.summary.toLowerCase().includes(kw) ||
      item.tags.some((tag) => tag.toLowerCase().includes(kw));
    return matchCategory && matchKeyword;
  });
}

export function getCategoryName(key: string): string {
  return categories.find((item) => item.key === key)?.name ?? '速览';
}